import React, { useEffect } from 'react';
import { Element } from 'react-scroll';
import sanitizeHtml from 'sanitize-html';
import Skeleton from 'react-loading-skeleton';

import { Place } from 'components';
import { TRACK, recordEvent } from 'utils/Track';

let requiredParagraphWords = ['Morning', 'Afternoon', 'Evening'];

// Remove any <p> tags that don't contain one of the required words
const removeUnnecessaryPTags = (str) => {
  let regex = new RegExp('(<p>)(?!.*(' + requiredParagraphWords.join('|') + '):).*?(<\/p>)', 'gs');
  return str.replace(regex, '');
};

const MINIMUM_DESCRIPTION_LENGTH = 20; // If day description HTML is less than this, don't show it

const Day = ({
  day,
  description = '',
  isOnlyDay = false,
  isDescriptionLoading = true,
  fullDescriptionsString = '',
  eventContext
  }) => {
  const mergedEventContext = {
    ...eventContext,
    day: day?.dayNumber + 1,
  };
  // const placeNamesWebsites = day?.places?.map(place => ({ name: place?.place?.name, website: place?.place?.website }));

  // const descriptionWithLinks = placeNamesWebsites.reduce((str, place) => {
  //   const regex = new RegExp(place.name, 'g');
  //   return str?.replace(regex, `<a href='${place?.website}' target='_blank'>${place?.name}</a>`);
  // }, description);

  const safeDescription = sanitizeHtml(removeUnnecessaryPTags(description), {
    allowedTags: ['p', 'strong', 'em'],
    allowedAttributes: {
      a: ['href', 'target']
    }
  });

  useEffect(() => {
    // When the first day's description is hidden because it was too short
    // if (day?.dayNumber === 0 && safeDescription?.length < MINIMUM_DESCRIPTION_LENGTH && !isDescriptionLoading) {
    //   console.log('%c Day descriptions not showing and likely filtered out', 'background: #222; color: #e74c3c');
    //   recordEvent(TRACK.EVENTS.FIRST_DAY_DESCRIPTION_NOT_SHOWING, {
    //     ...mergedEventContext,
    //     fullDescriptionsString,
    //     dayHtmlAfterOpenAIDescriptionSplit: description,
    //     sanitizedHtml: safeDescription,
    //   });
    // }
  }, [isDescriptionLoading]);

  return (
    <Element className='day-description' name={`day-${day?.dayNumber + 1}`}>
      <h2>{!isOnlyDay ? `Day ${day?.dayNumber + 1}` : null}</h2>
      {isDescriptionLoading ? (
        <Skeleton count={3} baseColor='#f9ebe7' highlightColor='#fcf5f4' />
      ) : null}
      <div dangerouslySetInnerHTML={{ __html: safeDescription?.length >= MINIMUM_DESCRIPTION_LENGTH ? safeDescription : '' }}></div>
      {day?.places?.map(place => <Place key={place?.id} place={place?.place} eventContext={mergedEventContext} />)}
    </Element>
  );
}

export default Day;
